/* Next */
//import Image from 'next-image-export-optimizer'

/* React */
import { useState, useEffect, useRef } from 'react'

/* Components */
import AppBar from './AppBar'

/* Template */
import HeaderTop from 'template/header/Header'
import { PageChrome } from 'src/pageBuilder/config'
import { MenuPageBuilder } from 'src/shared/dbTypes/menuPageBuilder'
import type { LandingPageImageAiGenerated } from 'src/functions/landingPageImageAiGenerated'

interface Props {
  pageChrome: PageChrome
  pageBuilder?: MenuPageBuilder
  landingPageImageAiGenerated?: LandingPageImageAiGenerated
}

const Header: React.FC<Props> = ({ pageChrome, pageBuilder, landingPageImageAiGenerated }) => {

  const [headerHeight, setHeaderHeight] = useState(100)
  const headerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (pageChrome.builderEnabled && pageChrome.hideLegacyHeader) {
      setHeaderHeight(0)
      return
    }
    if (headerRef === null) return
    if (headerRef.current === null) return
    setHeaderHeight(headerRef.current.clientHeight)
  },[pageChrome.builderEnabled, pageChrome.hideLegacyHeader])

  return <>

    {!(pageChrome.builderEnabled && pageChrome.hideLegacyHeader) &&
      <div ref={headerRef}>
        <HeaderTop />
      </div>
    }

    <AppBar headerHeight={headerHeight} {...{ pageChrome, pageBuilder, landingPageImageAiGenerated }} />

  </>
}

export default Header
